import { useState } from "react";

// helpers
import { deleteBox } from "../common/helper";

// components
import { Button } from "shared/components/bulma/button";

const DeleteBox = ({ customer, box, onClick }) => {
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        if (!window.confirm(`Are you sure you want to delete the box?`)) {
            return;
        }

        setLoading(true);
        await deleteBox({ customer, box });
        setLoading(false);
        if (onClick) { onClick(); }
    }

    return (
        <Button className={`is-small is-danger is-outlined ${loading ? 'is-loading' : ''}`} onClick={handleClick} >
            <span className="icon">
                <i className="fas fa-trash"></i>
            </span>
            <span>Delete</span>
        </Button>
    );
}

export { DeleteBox };
